/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：623
 */

module.exports = {
  importFailToast: "ImportFailToast_importFailToast__3tVmI",
  title: "ImportFailToast_title__3ROKD",
  extensional: "ImportFailToast_extensional__2yUVN",
  main: "ImportFailToast_main__2xCST",
  left: "ImportFailToast_left__1dypn",
  imgBox: "ImportFailToast_imgBox__sTGUb",
  errorMessage: "ImportFailToast_errorMessage__132t0",
  confirmButton: "ImportFailToast_confirmButton__3PFV7"
}
